import React, { useEffect, useState, useRef, useCallback} from 'react';
import { Grid,
  TextField,FormControl, Typography, Divider,
  Button, FormLabel, RadioGroup, FormControlLabel, Box,
  Radio, InputAdornment, FormGroup, Checkbox, Autocomplete,
  InputLabel, Select, MenuItem, List,
  ListItem, ListItemText, ListItemIcon
} from '@mui/material';
import { useForm, Controller } from "react-hook-form";
import TimePicker from '@mui/lab/TimePicker';
import DateAdapter from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import { Loader } from "@googlemaps/js-api-loader";
import { useSnackbar } from 'notistack';
import IconButton from '@mui/material/IconButton'
import DeleteIcon from '@mui/icons-material/Delete';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import {savePropertyData } from 'services/property';

const PropertyInfo = ({cities, states, onSuccess, propertyId = null, propertyData={} }) => {

  const defaultValues = {
    name: '',
    price: '',
    city:null,
    country:'India',
    state: null,  
    contactNumber: '',
    type: '',
    amenities: '',
    workingDays: '',
    pin:'',
    seatCount:'',
    overview:'',
    searchArea:'',
    hourlyBookingsEnabled: false,
  };

  const amenitiesList = {
    "AC": false,
    "Books": false,
    "Drinking Water": false,
    "Internet": false,
    "Parking": false,
    "Study Materials": false,
    "Wi-Fi": false
  };

  const weekDays = {
    "Sunday": false,
    "Monday": false,
    "Tuesday": false,
    "Wednesday": false,
    "Thursday": false,
    "Friday": false,
    "Saturday": false
  };

  /** Hooks */
  const [fromHrs, setFromHrs] = useState(new Date());
  const [toHrs, setToHrs] = useState(new Date());
  const [amenities, setAmenitiesState] = useState({...amenitiesList});
  const [workingDays, setWorkingDays] = useState({...weekDays});
  const [terms, setTerms] = useState([]);
  const [area, setArea] = useState('');
  const { enqueueSnackbar } = useSnackbar();
  const [locationCoordinates, setLocationCoordinates] = useState(getMapCoordinates(propertyData));
  const { handleSubmit, control, formState: { errors }, reset, watch } = useForm({
    mode: 'onTouched',
    defaultValues
  });
  const placesInputRef = useRef(null);
  const termsInputRef = useRef(null);
  const markerRef = useRef(null);
  const mapRef = useRef(null);
  const googleRef = useRef(null);

  useEffect(() => {
    loadGoogleMaps();
    // onSuccess({ libraryId: '775d7cca-5911-4c3b-8c1c-6e313a2b0d6c'});
    return () => {};
  }, []);

  useEffect(() => {
    if(propertyData){
      const {library: libraryInfo, libraryDetails, libraryMetadata, libraryTerms} = propertyData
      reset({
        name: libraryInfo.name,
        price: libraryInfo?.price?.cost,
        city: libraryInfo?.address?.city,
        country:'India',
        state: libraryInfo?.address?.state,  
        pin: libraryInfo?.address?.pin,
        seatCount:libraryInfo?.seatCount,
        contactNumber: libraryDetails?.contactNumber,
        type: libraryDetails?.type,
        amenities: '',
        workingDays: '',
        overview: libraryMetadata?.overview,
        hourlyBookingsEnabled: libraryInfo?.hourlyBookingsEnabled,
        // searchArea: libraryInfo.address.area,
      });
      setTerms([...(libraryTerms?.termsAndConditions || [])]);
      setArea(libraryInfo?.address?.area);
      setWorkingDays({...libraryDetails?.workingDays});
      placesInputRef.current.value = libraryInfo?.address?.area;
      if(libraryInfo?.address?.location?.latitude && libraryInfo?.address?.location?.longitude) {

        const cordinates = { lat: libraryInfo.address.location.latitude, lng: libraryInfo.address.location.longitude}
        setLocationCoordinates({latitude:cordinates.lat , longitude: cordinates.lng});
        // if(mapRef.current && googleRef.current) {
        //   markerRef.current = new googleRef.current.maps.Marker({
        //     position: {...cordinates},
        //     map: mapRef.current,
        //     title: 'Your Library'
        //   }); 
        //   mapRef.current.setCenter({ ...cordinates });
        //   mapRef.current.setZoom(12)
        // }
      }

      // Working hours
      if(libraryDetails?.workingHours?.from && libraryDetails?.workingHours?.to) {
        const from = new Date(new Date().toISOString().slice(0, 10) + ' ' + libraryDetails.workingHours.from);
        const to = new Date(new Date().toISOString().slice(0, 10) + ' ' + libraryDetails.workingHours.to);
        setFromHrs(from);
        setToHrs(to);
      }

      if(Array.isArray(libraryDetails?.amenities) && libraryDetails?.amenities?.length > 0) {
        setAmenitiesState({...(Object.fromEntries(Object.entries(amenitiesList).map(([amenity, status], index) => [amenity, libraryDetails.amenities.includes(amenity)])))});
      }

    }
  
    return () => {};
  }, [propertyData, reset]);

  function getMapCoordinates(_propertyData = {} ) {
    const { library: libraryInfo } = _propertyData || {};
    let cordinates = null;
    if(libraryInfo?.address?.location?.latitude && libraryInfo?.address?.location?.longitude) {
      cordinates = { latitude: libraryInfo.address.location.latitude, longitude: libraryInfo.address.location.longitude};
      return cordinates;
    }
    return cordinates;
  }
  
  useEffect(() => {
    if(locationCoordinates?.latitude && locationCoordinates?.longitude && googleRef.current?.maps) {
      const cordinates = { lat: locationCoordinates.latitude, lng: locationCoordinates.longitude}
      if (markerRef.current == null) {
        markerRef.current = new googleRef.current.maps.Marker({
            position: {...cordinates},
            map: mapRef.current,
            title: 'Your Library'
        }); 
      } else {
        markerRef.current.setPosition({...cordinates}); 
      } 
      mapRef.current.setCenter({ ...cordinates });
      mapRef.current.setZoom(12)
    }
    return () => {};
  }, [locationCoordinates, mapRef]);
  
  
  const loadGoogleMaps = useCallback(() => {
    const mapOptions = {
      center: {
        lat: 12.9715987,
        lng: 77.5945627
      },
      zoom: 12,
      // disableDefaultUI: true,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
    };

    const loader = new Loader({
      apiKey: "AIzaSyCy5CeZ-EXuV8dpaIXi5-hEomhJVwdBVV8",
      version: "weekly",
      libraries: ["places"],
      componentRestrictions: {country: 'in' }
    });

    loader.load().then((google) => {
      googleRef.current =  google;
      const mapEle = document.getElementById("map");
      mapRef.current =  new google.maps.Map(mapEle, mapOptions);

      google.maps.event.addListener(mapRef.current, 'click', function(event) {
        const location = event.latLng;
        // if (markerRef.current == null) {
        //   markerRef.current = new google.maps.Marker({
        //       position: location,
        //       map: mapRef.current,
        //       title: 'Your Library'
        //   }); 
        // } else {
        //   markerRef.current.setPosition(location); 
        // } 
        setLocationCoordinates({latitude:location.lat() , longitude: location.lng()});
      });
      initPlacesAutoComplete(google, mapRef.current); 

      if(locationCoordinates.latitude && locationCoordinates.longitude) {
        const cordinates = { lat: locationCoordinates.latitude, lng: locationCoordinates.longitude}
        markerRef.current = new googleRef.current.maps.Marker({
          position: {...cordinates},
          map: mapRef.current,
          title: 'Your Library'
        }); 
        mapRef.current.setCenter({ ...cordinates });
        mapRef.current.setZoom(12);
      }
    })
    .catch(e => {
      // do something
    });
    
  },[locationCoordinates, locationCoordinates]);

  const initPlacesAutoComplete = (google, map) => {

    const options = {
      fields: [ "geometry","name" ],
      componentRestrictions: {country: 'in'},
      // strictBounds: false,
      // types: ["establishment"],
    };
    const autocomplete = new google.maps.places.Autocomplete(placesInputRef.current, options);
    autocomplete.addListener("place_changed", () => {
      // infowindow.close();
      // marker.setVisible(false);
      const place = autocomplete.getPlace();

      // setValue('searchArea', place.formatted_address, {shouldValidate: true, shouldDirty: true});
      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();

      map.setCenter({lat, lng});
      map.setZoom(12)
      setArea(place.name);
    });
  };

  const handleAmenitiesChange = (event) => {
    setAmenitiesState({
      ...amenities,
      [event.target.name]: event.target.checked,
    });
  };

  const handleWorkingDaysChange = (event) => {
    setWorkingDays({
      ...workingDays,
      [event.target.name]: event.target.checked,
    });
  };
  
  const AddTerms = () => {
    if(termsInputRef.current.value){
      setTerms([...terms, termsInputRef.current.value]);
      termsInputRef.current.value = '';
    } else{
      enqueueSnackbar("Add Terms", {variant: 'error'});
    }
  }

  const deleteTerms = (index) => {
    const temp = [...terms];
    temp.splice(index, 1);
    setTerms([...temp]);
  }


  const onSubmit = (data) => {
    if(!locationCoordinates) {
      enqueueSnackbar("Select library location", {variant: 'error'});
    } else if(!isWorkingDaySelected()) {
      enqueueSnackbar("Select working days", {variant: 'error'});
    } else if(terms.length === 0) {
      enqueueSnackbar("Add Terms", {variant: 'error'});
    } else {
      const postData = formatFormData(data);
      addProperty(postData);
    }
  }

  const isWorkingDaySelected = () => ([...(Object.keys(Object.fromEntries(Object.entries(workingDays).filter(([key, value]) => value === true) )))].length > 0);

  const formatFormData = (inputData) => {
    const data = {
      library: {
        libraryId: propertyId,
        address: {
          area,
          city: inputData.city,
          state: inputData.state, 
          country: inputData.country, 
          pin: inputData.pin,
          location: {...locationCoordinates} 
        },
        name: inputData.name,
        hourlyBookingsEnabled: inputData.hourlyBookingsEnabled,
        price: {
          cost: parseFloat(inputData.price),
          rate: inputData.hourlyBookingsEnabled ? 'hour' : 'day'
        },
        seatCount: inputData.seatCount,
      },
      libraryDetails: {
        amenities: [
          ...(Object.keys(Object.fromEntries(Object.entries(amenities).filter(([key, value]) => value === true) )))
        ],
        contactNumber: inputData.contactNumber,
        workingDays: {...workingDays},
        workingHours: {
          from: `${new Date(fromHrs).getHours().toString().padStart(2, "0")}:${new Date(fromHrs).getMinutes().toString().padStart(2, "0")}`,
          to: `${new Date(toHrs).getHours().toString().padStart(2, "0")}:${new Date(toHrs).getMinutes().toString().padStart(2, "0")}`,
        },
        type: inputData.type
      },
      libraryMetadata: {
        overview: inputData.overview
      },
      libraryTerms: {
        termsAndConditions: [
          ...terms
        ]
      }
    };
    return data;
  }

  const addProperty = (postData) => {
    savePropertyData(postData).then(({response, error}) => {
      if(response){
        var msg = propertyId ? 'Library details have been submitted for approval. You will see the changes once approved.' : "Library added successfully";
        enqueueSnackbar(msg, {variant: 'success'});
        onSuccess(response);
      } else {
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }
  return (
    <Box sx={{ mb: 2, mt:2, px: 4 }} noValidate component="form"  onSubmit={handleSubmit(onSubmit)} >
      <Grid container columnSpacing={6}>
        <Grid container columnSpacing={2} item xs={12} sm={12} md={6} lg={6}>
          <Grid item xs={12} sm={12} md={12} lg={12}  >
            <Controller
              control={control}
              name="name"
              id="name"
              rules={{ required: "Enter your library name" }}
              render={({field }) => (
                <TextField
                  {...field}
                  margin="normal"
                  fullWidth
                  size="small"
                  autoFocus
                  label="Library Name"
                  required
                  error={!!errors?.name}
                  // helperText={errors.firstName?.message}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}  sx={{mt: 1.9}}>
            <Controller
              control={control}
              name="city"
              id="city"
              rules={{ required: "Enter your city" }}
              required
              render={({field }) => (
                <Autocomplete
                  {...field}
                  required
                  disablePortal
                  size="small"
                  options={cities}
                  fullWidth
                  // value={selectedCity}
                  isOptionEqualToValue={(option, value) => option === value}
                  onChange={(event, newValue) => {field.onChange(newValue)}}
                  renderInput={(params) => <TextField {...params} error={!!errors?.city} required label="City" />}
                />
              )}
              onChange={([, data]) => data}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}  sx={{mt: 1.9}}>
            <Controller
              control={control}
              name="state"
              id="state"
              rules={{ required: "Enter your state" }}
              render={({field }) => (
                <Autocomplete
                  {...field}
                  // disablePortal
                  options={states}
                  size="small"
                  name="state"
                  fullWidth={true}
                  // value={selectedState}
                  isOptionEqualToValue={(option, value) => option === value}
                  onChange={(event, newValue) => {field.onChange(newValue)}}
                  renderInput={(params) => <TextField {...params} {...field} error={!!errors?.state}  required label="State" />}
                />
              )}
              onChange={([, data]) => data}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}  sx={{mt: 3}}>
            <Controller
              control={control}
              required
              name="country"
              id="country"
              rules={{ required: "Enter your country" }}
              render={({field }) => (
                <FormControl {...field} fullWidth error={!!errors?.country}>
                  <InputLabel id="country-label">Country</InputLabel>
                  <Select    
                    name="country"                 
                    labelId="country-label"
                    id="country-select"
                    label="Country"
                    size="small"
                    {...field}
                  >
                    <MenuItem value="India">India</MenuItem>
                  </Select>
                </FormControl>
              )}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} sx={{mt: 0.9}}>
            <Controller
              control={control}
              name="pin"
              required
              id="pin"
              rules={{
                required: "Enter pincode",
                pattern: {
                  value: /^[0-9]{6,6}$/i,
                  message: "Pincode must be valid digits",
                }, 
                minLength: {
                  value: 6,
                  message: "Pincode must be 6 digits"
                },
                maxLength: {
                  value: 6,
                  message: "Pincode must 6 digits"
                }
              }}
              render={({field}) => (
                <TextField
                  {...field}
                  margin="normal"
                  label="Pincode"
                  required
                  error={!!errors?.pin}
                  helperText={errors?.pin?.message}
                  size="small"
                  fullWidth
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} sx={{ position: 'relative'}}>
            {/* <Controller
              control={control}
              name="searchArea"
              id="searchArea"
              required
              rules={{ required: "Enter search area" }}
              render={({field}) => ( */}
                <TextField
                  // {...field}
                  margin="normal"
                  label="Search Area"
                  required
                  size="small"
                  fullWidth
                  inputRef={placesInputRef}
                  // error={!!errors?.searchArea}
                  // error={!locationCoordinates}
                />
              {/* )}
            /> */}
            <Box id="map" component="div" sx={{width: '100%', height: 300}}></Box>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} >
            <Controller
              control={control}
              name="contactNumber"
              id="contactNumber"
              rules={{
                required: "Enter Contact Number",
                pattern: {
                  value: /^[0-9]{0,100}$/i,
                  message: "Contact number must be valid digits",
                }, 
              }}
              render={({field}) => (
                <TextField
                  {...field}
                  margin="normal"
                  label="Contact Number"
                  required
                  error={!!errors?.contactNumber}
                  helperText={errors?.contactNumber?.message}
                  size="small"
                  fullWidth
                />
              )}
            />
          </Grid>
        </Grid>
        <Grid container columnSpacing={2} item xs={12} sm={12} md={6} lg={6}>

          <Grid item xs={12} sm={12} md={12} lg={12} sx={{mt: 1}}>
            <FormControl error={!!errors?.type} >
              <FormLabel id="lib-type-group-label">Library Type *</FormLabel>
              <Controller
                control={control}
                name="type"
                id="type"
                required
                rules={{ required: "Select library type" }}
                render={({field}) => (
                  <RadioGroup
                    {...field}
                    row
                    aria-labelledby="lib-type-group-label"
                    name="type"
                  >
                    <FormControlLabel value="Academic" control={<Radio />} label="Academic" />
                    <FormControlLabel value="Private" control={<Radio />} label="Private" />
                    <FormControlLabel value="Public" control={<Radio />} label="Public" />
                    <FormControlLabel value="School" control={<Radio />} label="School" />
                  </RadioGroup>
                )}
              />
            </FormControl>
          </Grid> 
        
          
          <Grid item xs={12} sm={12} md={12} lg={12} >
            <Controller
              control={control}
              name="hourlyBookingsEnabled"
              id="hourlyBookingsEnabled"
              render={({field}) => (
                <FormControl
                  component="fieldset"
                  sx={{ mt: 2.5 }}
                  variant="standard"
                  {...field}
                >
                  <FormGroup row>
                    <FormControlLabel
                      control={<Checkbox name="hourlyBookingsEnabled" />}
                      label="Enable hourly bookings"
                      checked={watch('hourlyBookingsEnabled') || false}
                    />
                  </FormGroup>
                </FormControl>
              )}
            />
          </Grid>

          <Grid item xs={12} sm={12} md={6} lg={6} >
            <Controller
              control={control}
              name="seatCount"
              id="seatCount"
              rules={{
                required: "Enter number of seats",
                pattern: {
                  value: /^[0-9]{0,100}$/i,
                  message: "Only number are allowed",
                }, 
              }}
              render={({field}) => (
                <TextField
                  {...field}
                  margin="normal"
                  label="Number of Seats"
                  required
                  error={!!errors?.seatCount}
                  helperText={errors?.seatCount?.message}
                  size="small"
                  fullWidth
                />
              )}
            />
          </Grid>
          
          <Grid item xs={12} sm={12} md={6} lg={6} >
            <Controller
              control={control}
              name="price"
              id="price"
              rules={{ required: "Enter price" }}
              render={({field}) => (
                <TextField
                  type="number"
                  {...field}
                  margin="normal"
                  label="Price"
                  required
                  error={!!errors?.price}
                  size="small"
                  InputProps={{
                    endAdornment: <InputAdornment position="start">/{watch('hourlyBookingsEnabled') ? 'hour' : 'day'}</InputAdornment>,
                  }}
                  fullWidth
                />
              )}
            />
          </Grid>
          
          <Grid container item xs={12} sm={12} md={12} lg={12} sx={{mt: 2.5}} columnSpacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} sx={{mb: 2.5}}>
              <label style={{color: 'rgba(0, 0, 0, 0.6)'}}>Working Hours *</label>
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6} >
              <LocalizationProvider dateAdapter={DateAdapter} >
                <TimePicker
                  ampm={false}
                  label="From"
                  
                  // inputFormat="dd/MM/yyyy"
                  clearable={false}
                  value={fromHrs}
                  onChange={(newValue) => setFromHrs(newValue)}
                  renderInput={(params) => <TextField onKeyDown={(e) => {e.preventDefault();return false}}  {...params} size="small" sx={{width: '100%'}} />}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6} >
              <LocalizationProvider dateAdapter={DateAdapter} >
                <TimePicker
                  ampm={false}
                  label="To"
                  // inputFormat="dd/MM/yyyy"
                  clearable={false}
                  value={toHrs}
                  onChange={(newValue) => setToHrs(newValue)}
                  renderInput={(params) => <TextField onKeyDown={(e) => {e.preventDefault();return false}} {...params} size="small" sx={{width: '100%'}} />}
                />
              </LocalizationProvider>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} >
            <Controller
              control={control}
              name="amenities"
              id="amenities"
              render={({field}) => (
                <FormControl
                  component="fieldset"
                  sx={{ mt: 2.5 }}
                  variant="standard"
                  {...field}
                >
                  <FormLabel component="legend" required>Amenities</FormLabel>
                  <FormGroup row>
                    {Object.keys(amenities).map((type, index) => (
                      <FormControlLabel
                        control={<Checkbox name={type} />}
                        label={type}
                        onChange={handleAmenitiesChange} 
                        checked={amenities[type] || false}
                        key={type}
                      />
                    ))}
                  </FormGroup>
                </FormControl>
              )}
            />
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12} >
            {/* <Controller
              control={control}
              name="workingDays"
              id="workingDays"
              render={({field}) => ( */}
                <FormControl
                  component="fieldset"
                  sx={{ mt: 2.5 }}
                  variant="standard"
                  // {...field}
                >
                <FormLabel required component="legend">Working Days</FormLabel>
                  <FormGroup row>
                    {Object.keys(weekDays).map((day, index) => (
                      <FormControlLabel
                        control={<Checkbox name={day.toLocaleLowerCase()} />}
                        label={day}
                        onChange={handleWorkingDaysChange} 
                        checked={workingDays[day.toLocaleLowerCase()] || false}
                        key={day.toLocaleLowerCase()}
                      />
                    ))}
                  </FormGroup>
                </FormControl>
              {/* )}
            /> */}
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12} >
            <Controller
              control={control}
              name="overview"
              id="overview"
              rules={{ required: "Enter overview" }}
              render={({field}) => (
                <TextField
                  {...field}
                  multiline
                  rows={5}
                  margin="normal"
                  label="Overview"
                  required
                  error={!!errors?.overview}
                  size="small"
                  fullWidth
                />
              )}
            />
          </Grid>
          
        </Grid>
        
        <Grid container item xs={12} sm={12} md={12} lg={12} sx={{mt: 2}}>
          <Grid item xs={12} sm={12} md={12} lg={12} >
            <Typography variant="h6" gutterBottom component="div">Terms</Typography>
            <Divider />
          </Grid>

          <Grid item xs={12} sm={12} md={5} lg={5} >
            <TextField
              multiline
              rows={5}
              margin="normal"
              label="Add text here"
              size="small"
              fullWidth
              inputRef={termsInputRef}
            />
            <Button
            type="button"
            variant="contained"
            sx={{ mt: 4, mb: 2 }}
            startIcon={<ControlPointIcon />}
            // color="success"
            onClick={AddTerms}
          >
            Add
          </Button>
          
            <List dense={true}>
              {terms.map((ele, index) => (
                <ListItem key={index}
                  secondaryAction={
                    <IconButton edge="end" aria-label="delete" onClick={() => deleteTerms(index)}>
                      <DeleteIcon />
                    </IconButton>
                  }
                >
                <ListItemIcon>
                  <ArrowRightIcon />
                </ListItemIcon>
                <ListItemText
                  primary={ele}
                    // secondary={secondary ? 'Secondary text' : null}
                  />
                </ListItem>
              ))}
            </List>
            
          </Grid>
        </Grid>

        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Button
            type="submit" 
            variant="contained"
            sx={{ mt: 4, mb: 2 }}
            startIcon={ propertyId ? <ModeEditIcon />: <ControlPointIcon />}
            color="success"
          >
            {propertyId ? 'Update' : 'Add'}
          </Button>
        </Grid>
      </Grid>
    </Box>
      
  );
}
 
export default React.memo(PropertyInfo);
